import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SupplyBoatBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SUPPLY_BOAT;
}

export default SupplyBoatBuildingTileEntity;
